import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { Button } from '@lb-service/ui';
import appUtils from '../../../../utils/appUtils';

const FreeConversationHero = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { locale } = router;
  return (
    <div className="hero font-white">
      <div className="hero-background background-free-conversation" />
      <div className="courses-hero-content max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        <div className="va-container va-container-v va-container-h">
          <div className="va-middle">
            <div className="max-w-2xl mx-auto">
              <div className="text-center col-center lg:col-span-8">
                <h1 className="text-3xl text-white mb-4">
                  {t('service.courses.freeConversation.hero.title')}
                </h1>
                <h2 className="text-xl text-white mb-8">
                  <span>
                    {t('service.courses.freeConversation.hero.intro')}
                  </span>
                  <br />
                </h2>
                <Button size="lg" asChild>
                  <a href={appUtils.getAppPath(locale, 'signup')}>
                    <span className="text-center">{t('links.signup')}</span>
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default FreeConversationHero;
